import React, {Component} from 'react'
import i18 from '../../../i18'

class Row extends Component {

    constructor(props) {
        super(props)
        this.state = {
            rule: props.rule,
            company: props.company,
            vatCodes: props.vatCodes
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            rule: nextProps.rule,
            company: nextProps.company,
            vatCodes: nextProps.vatCodes,
        })
    }

    onEditRule = (event) => {
        this.props.onEditRule(this.state.rule)
    }

    onRemoveRule = (event) => {
        this.props.onRemoveRule(this.state.rule)
    }

    getRuleType = () => {
        return this.state.rule.type === 'final' ? i18.COMMON._finalRule : i18.COMMON._temporarirlyRule
    }

    getCompanyType = () => {
        switch (this.state.rule.company_type) {
            case 'HU':
                return i18.COMMON._hu
            case 'NON_EU':
                return i18.COMMON._non_eu
            case 'EU':
                return i18.COMMON._eu
            default:
                return ''
        }
    }


    render() {
        return (
            <tr>
                <td>{this.state.rule.item_name}</td>
                <td>{this.state.rule.invoice_number}</td>
                <td>{this.state.rule.main_bookkeeping_number}</td>
                <td>{this.state.rule.vat}%</td>
                <td>{this.props.vatCode ? this.props.vatCode.code : null}</td>
                <td>{this.getCompanyType()}</td>
                <td>{this.state.rule.vat_degree}</td>
                <td>{this.getRuleType()}</td>
                <td>{this.state.rule.position}</td>
                <td>{this.state.rule.updated_at}</td>
                <td>
                    <i onClick={(event) => this.onEditRule(event)} title={i18.CUSTOMER._editRule} className='fa fa-pencil-square-o' aria-hidden='true'/> &nbsp;&nbsp;
                    <i onClick={(event) => this.onRemoveRule(event)} title={i18.CUSTOMER._deleteRule} className='fa fa-trash-o' aria-hidden='true'/>
                </td>
            </tr>
        )
    }
}

export default Row


// WEBPACK FOOTER //
// ./src/components/customer/Rules/Row.js